if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        // this.elements.viewer.addEventListener('scroll', () => {
        //   this.handleActiveVideo();
        // });
        // let scrollTimeout;

        // this.elements.viewer.addEventListener('scroll', () => {
        //   clearTimeout(scrollTimeout);

        //   scrollTimeout = setTimeout(() => {
        //     requestAnimationFrame(() => {
        //       this.syncActiveSlideWithThumbnail();
        //     });
        //   }, 180);
        // });
        // this.observeActiveSlide();
        // this.initFirstInteraction();
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        // setTimeout(() => {
        //   this.handleActiveVideo();
        // }, 300);

        this.initVideoObserver();
      }

      initVideoObserver() {
        const slides = this.elements.viewer.querySelectorAll('[data-media-id]');

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const slide = entry.target;

              if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
                // 👉 slide is ACTIVE (60% visible)

                const mediaId = slide.dataset.mediaId;

                const thumbnailBtn = this.elements.thumbnails.querySelector(
                  `[data-target="${mediaId}"] button`
                );

                if (!thumbnailBtn) return;

                // prevent duplicate clicks
                if (thumbnailBtn.hasAttribute("aria-current")) return;

                // 🔥 trigger thumbnail click
                // thumbnailBtn.dispatchEvent(new Event('click', { bubbles: true }));

                this.isAutoScrolling = true;
                this.setActiveMedia(mediaId, false);

                setTimeout(() => {
                  this.isAutoScrolling = false;
                }, 100);

                // this.setActiveMedia(mediaId, false);

                const deferredMedia = slide.querySelector("deferred-media");

                if (deferredMedia && !slide.querySelector("video")) {
                  deferredMedia.loadContent(false);
                }

                const waitForVideo = () => {
                  const video = slide.querySelector("video");

                  if (video) {
                    this.playVideo(video, slide);
                  } else {
                    requestAnimationFrame(waitForVideo);
                  }
                };

                waitForVideo();

              } else {
                // 👉 slide is NOT active → stop video
                const video = slide.querySelector("video");
                if (video) {
                  video.pause();
                  video.currentTime = 0;
                }
              }
            });
          },
          {
            root: this.elements.viewer,
            threshold: [0.6], // 🔥 key value
          }
        );

        slides.forEach((slide) => observer.observe(slide));
      }

      // initFirstInteraction() {
      //   let initialized = false;

      //   const init = () => {
      //     if (initialized) return;
      //     initialized = true;

      //     // 🔥 Load ALL deferred videos once
      //     const deferredItems = this.elements.viewer.querySelectorAll("deferred-media");

      //     deferredItems.forEach((item) => {
      //       if (!item.querySelector("video")) {
      //         item.loadContent(false);
      //       }
      //     });

      //     // Run video logic after loading
      //     // setTimeout(() => {
      //     //   this.handleActiveVideo();
      //     // }, 300);
      //   };

      //   // Trigger on first user interaction
      //   this.elements.viewer.addEventListener("touchstart", init, { once: true });
      //   this.elements.viewer.addEventListener("scroll", init, { once: true });
      // }

      // syncActiveSlideWithThumbnail() {
      //   const slides = this.elements.viewer.querySelectorAll('[data-media-id]');
      //   let activeSlide = null;
      //   let maxVisibleArea = 0;

      //   slides.forEach((slide) => {
      //     const rect = slide.getBoundingClientRect();

      //     const visibleWidth =
      //       Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0);

      //     const visibleArea = Math.max(0, visibleWidth);

      //     if (visibleArea > maxVisibleArea) {
      //       maxVisibleArea = visibleArea;
      //       activeSlide = slide;
      //     }
      //   });

      //   if (!activeSlide) return;

      //   // 🔥 CHECK IF THIS SLIDE HAS VIDEO
      //   const hasVideo =
      //     activeSlide.querySelector("video") ||
      //     activeSlide.querySelector("deferred-media");

      //   if (!hasVideo) return; // ❌ do nothing if not video

      //   const mediaId = activeSlide.dataset.mediaId;

      //   const thumbnailBtn = this.elements.thumbnails.querySelector(
      //     `[data-target="${mediaId}"] button`
      //   );

      //   if (!thumbnailBtn) return;

      //   // prevent duplicate clicks
      //   if (thumbnailBtn.hasAttribute("aria-current")) return;

      //   // 🔥 FORCE CLICK AFTER SLIDE ENDS
      //   setTimeout(() => {
      //     thumbnailBtn.dispatchEvent(new Event('click', { bubbles: true }));
      //   }, 50);
      // }

      // observeActiveSlide() {
      //   const observer = new MutationObserver(() => {
      //     this.handleActiveVideo();
      //   });

      //   observer.observe(this.elements.viewer, {
      //     subtree: true,
      //     attributes: true,
      //     attributeFilter: ['class'],
      //   });
      // }

     playVideo(video, activeSlide) {
      const deferredMedia = activeSlide.querySelector("deferred-media");

      // hide poster
      if (deferredMedia) {
        const poster = deferredMedia.querySelector(".deferred-media__poster");
        if (poster) {
          poster.style.display = "none";
          poster.style.visibility = "hidden";
          poster.style.opacity = "0";
          poster.style.pointerEvents = "none";
        }
        deferredMedia.setAttribute("loaded", "true");
      }

      // 🔥 REQUIRED FOR MOBILE AUTOPLAY
      video.muted = false;
      video.defaultMuted = false;

      video.setAttribute("muted", "");
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");

      // 🔥 FORCE PLAY

      if (window.innerWidth > 767) {
        video.play().catch(() => {});
      }

      video.onplay = () => {
        video.setAttribute("poster", ""); // remove poster attribute to prevent fallback image on some browsers
      };
    }

      // handleActiveVideo() {
      //   const slides = this.elements.viewer.querySelectorAll('[data-media-id]');
      //   let activeSlide = null;
      //   let maxVisibleArea = 0;

      //   slides.forEach((slide) => {
      //     const rect = slide.getBoundingClientRect();

      //     const visibleWidth =
      //       Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0);

      //     const visibleArea = Math.max(0, visibleWidth);

      //     if (visibleArea > maxVisibleArea) {
      //       maxVisibleArea = visibleArea;
      //       activeSlide = slide;
      //     }

      //     const video = slide.querySelector("video");
      //     const deferredMedia = slide.querySelector("deferred-media");

      //     // ⏸ STOP NON-ACTIVE
      //     if (video && !slide.classList.contains("is-active")) {
      //       video.pause();
      //       video.currentTime = 0;
      //     }

      //     // restore poster
      //     if (deferredMedia && !slide.classList.contains("is-active")) {
      //       const poster = deferredMedia.querySelector(".deferred-media__poster");
      //       if (poster) {
      //         poster.style.display = "";
      //         poster.style.visibility = "";
      //         poster.style.opacity = "";
      //         poster.style.pointerEvents = "";
      //       }
      //     }
      //   });

      //   if (!activeSlide) return;

      //   const deferredMedia = activeSlide.querySelector("deferred-media");

      //   if (deferredMedia && !activeSlide.querySelector("video")) {
      //     deferredMedia.loadContent(false);

      //     // 🔥 WAIT UNTIL VIDEO IS ACTUALLY IN DOM
      //     const checkVideo = () => {
      //       const video = activeSlide.querySelector("video");

      //       if (video) {
      //         this.playVideo(video, activeSlide);
      //       } else {
      //         requestAnimationFrame(checkVideo);
      //       }
      //     };

      //     checkVideo();
      //     return;
      //   }

      //   // 🔥 HIDE POSTER
      //   if (deferredMedia) {
      //     const poster = deferredMedia.querySelector(".deferred-media__poster");
      //     if (poster) {
      //       poster.style.display = "none";
      //       poster.style.visibility = "hidden";
      //       poster.style.opacity = "0";
      //       poster.style.pointerEvents = "none";
      //     }
      //     deferredMedia.setAttribute("loaded", "true");
      //   }

      //   const video = activeSlide.querySelector("video");
      //   if (!video) return;

      //   this.playVideo(video, activeSlide);
      // }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
        // window.pauseAllMedia();

        // this.handleActiveVideo();

        const activeSlide = event.detail.currentElement;

        const deferredMedia = activeSlide.querySelector("deferred-media");

        if (deferredMedia && !activeSlide.querySelector("video")) {
          deferredMedia.loadContent(false);
        }

        const waitForVideo = () => {
          const video = activeSlide.querySelector("video");

          if (video) {
            this.playVideo(video, activeSlide);
          } else {
            requestAnimationFrame(waitForVideo);
          }
        };

        waitForVideo();

        console.log("Slide Changed");
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
          
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            // activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });

            if (!this.isAutoScrolling) {
              activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
            }
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        // this.playActiveMedia(activeMedia);

       
        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);

        // this.handleActiveVideo();


        // 🔥 PLAY VIDEO ON THUMBNAIL CLICK (DESKTOP FIX)

        const activeSlide = activeMedia;

        const deferredMedia = activeSlide.querySelector("deferred-media");

        // load if needed
        if (deferredMedia && !activeSlide.querySelector("video")) {
          deferredMedia.loadContent(false);
        }

        // wait for video properly
        const waitForVideo = () => {
          const video = activeSlide.querySelector("video");

          if (video) {
            this.playVideo(video, activeSlide);
          } else {
            requestAnimationFrame(waitForVideo);
          }
        };

        waitForVideo();
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
